/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import { Pipe, PipeTransform } from '@angular/core';
import { num2abbrStr } from '../utils/math.utils';

/**
 * @description Pipe to convert a large number to a human-readable string.
 * @author alextsg
 */

@Pipe({
    name: 'num2abbrStr',
})
export class Num2abbrStrPipe implements PipeTransform {
    /** @override */
    public transform(value: number, precision?: number): string {
        return num2abbrStr(value, precision);
    }
}
